import {
  http
} from '../config';
import base from './base';
export const studyPlan = {
  getLearnPlanDetails(userId, dateBookId) { //查看学员学习计划详情
    return http({
      url: `${base.config}/teaLearnPlan/learnPlanDetails/${userId}/${dateBookId}`,
      method: 'get',
    });
  },
  bookGroupList() { //查询教材列表
    return http({
      url: `${base.config}/teaLearnPlan/bookGroupList`,
      method: 'get',
    });
  },
  queryBookList(bookGroupId) { //查询分册列表
    return http({
      url: `${base.config}/teaLearnPlan/bookList/${bookGroupId}`,
      method: 'get',
    });
  },
  learnGoalAndPoint() { //查询学习目的和学习重点
    return http({
      url: `${base.config}/teaLearnPlan/learnGoalAndPoint`,
      method: 'get',
    });
  },
  addLearnPlan(data) { //新增学习计划
    return http({
      url: `${base.config}/teaLearnPlan/learnPlan`,
      method: 'post',
      data
    });
  },
  editLearnPlan(data) { //编辑学习计划
    return http({
      url: `${base.config}/teaLearnPlan/editLearnPlan`,
      method: 'post',
      data
    });
  },
  getLearnPlanMessage(userId, dateBookId) { //计划收录信息
    return http({
      url: `${base.config}/teaLearnPlan/learnPlanMessage/${userId}/${dateBookId}`,
      method: 'get',
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/studyPlan.js